import { createReducer, on } from '@ngrx/store';
import { deleteUser, getUser, loginFailure, logoutUser, setUser, updateUser } from '../actions/auth.actions';

export interface AuthState {
  userData: any;
  loginError: any;
}

export const initialState: AuthState = {
  userData: {
    email: null,
    betaAccess: false,
    raiModeEnabled: false
  },
  loginError: null
};

export const authReducer = createReducer(
  initialState,
  on(getUser, (state, { authApiConstants }) => ({
    ...state,
    ...authApiConstants
  })),
  on(setUser, (state, { userData }) => {
    return {
      ...state,
      ...{ userData }
    };
  }),
  on(updateUser, (state, { userData }) => {
    return {
      ...state,
      ...{ userData }
    };
  }),
  on(deleteUser, (state, { userData }) => {
    return {
      ...state,
      ...{ userData }
    };
  }),
  on(logoutUser, (state) => {
    return {
      ...state,
      ...{ userData: 'LOGGED_OUT' }
    };
  }),
  on(loginFailure, (state, { loginError }) => {
    return {
      ...state,
      ...{ loginError }
    };
  })
);
